































































































import "@/assets/css/split.css";
import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import AbpBase from "@/lib/abpbase";
import PageRequest from "@/store/entities/page-request";
import Moment from "moment-timezone";
import ReadList from "./pressurelist.vue";
import checkAuth from "@/lib/Common/checkauth";


class PageMeterInfoRequest extends PageRequest {
  keyword: string;
  areaId: number;
  supplierId: number;
  deviceType: number;
  isEnabel: number;
}

@Component({
  components: {
    ReadList,
  },
})
export default class Pressure extends AbpBase {
  //filters
  pagerequest: PageMeterInfoRequest = new PageMeterInfoRequest();
  columnlist: any[] = [];
  searchName: string = ""; //树形搜索名称
  areaTree: any[] = [];
  areaTreeList: any[] = [];
  collectorList: any[] = [];
  modelType: any[] = [];
  choosemeters: Array<any> = [];
  pressurelist: any[] = [];
  height: number = 300; //表格高度
  menuId: number = 0;
  pressureId: string = null; //压力计Id
  choosecolumn: any[] = [];
  splitnum: number = 0.15;

  showcolumn: boolean = false; //显示列选择窗口
  readlistModalShow: boolean = false; //采集记录

  //检测按钮权限
  checkButtonAuth(tag: string) {
    return checkAuth.CheckButton(tag);
  }
  //获取自定义字段
  async getuserfields() {
    let menulist = JSON.parse(localStorage.getItem("userAuth"));
    let menu = menulist.filter((ele) => {
      return ele.value == "pressureinfo";
    });
    if (menu.length > 0) {
      this.menuId = menu[0].id;
    }
    let res = await this.$store.dispatch({
      type: "userfield/getuserfield",
      data: { menuId: this.menuId },
    });
    //把列加入右边列表
    this.columns.forEach((ele) => {
      if (ele.sortId != 0 && ele.sortId != 1) {
        this.choosecolumn.push({
          fieldName: ele.key,
          isShow: true,
          sortCode: ele.sortId,
          showTag: ele.title,
          menuId: this.menuId,
        });
      }
    });
    //如果设置了自定义列
    if (res.length > 0) {
      let se = this.columns.filter((ele) => {
        return ele.sortId == 0 || ele.sortId == 1;
      });
      se.forEach((ele) => {
        this.columnlist.push(ele);
      });
      let restrue = res.filter((ele) => {
        return ele.isShow == true;
      });
      //this.choosecolumn = res;
      restrue.forEach((ele) => {
        let col = this.columns.filter((colum) => {
          return colum.key == ele.fieldName;
        });
        //加入显示列
        if (col.length > 0) {
          col[0].sortId = ele.sortCode;
          this.columnlist.push(col[0]);
        }
      });
      this.choosecolumn.forEach((ele) => {
        let col = restrue.filter((colum) => {
          return colum.fieldName == ele.fieldName;
        });
        if (col.length > 0) {
          ele.isShow = col[0].isShow;
        }
      });
    } else {
      this.columnlist = this.columns;
    }
    this.columnlist.sort((left, right): number => {
      if (left.sortId > right.sortId) return 1;
      if (left.sortId < right.sortId) return -1;
      return 0;
    });
  }
  //改变显示
  handleChange(event: any, val: any) {
    if (event) {
      //选中显示
      let showcol = this.columns.filter((col) => {
        return col.key === val;
      });
      if (showcol.length > 0) {
        let sh = this.choosecolumn.filter((p) => {
          return p.fieldName == val;
        });
        if (sh.length > 0) {
          showcol[0].sortId = sh[0].sortCode;
        }
        this.columnlist.push(showcol[0]);
      }
    } else {
      //不显示
      this.columnlist = this.columnlist.filter((col) => {
        return col.key !== val;
      });
    }
    //排序
    this.columnlist.sort((left, right): number => {
      if (left.sortId > right.sortId) return 1;
      if (left.sortId < right.sortId) return -1;
      return 0;
    });
  }
  isActiveChange(val: number) {
    this.$store.commit("pressureinfo/setCurrentPage", 1);
    this.getpage();
  }
  get list() {
    return this.$store.state.pressureinfo.list;
  }
  get loading() {
    return this.$store.state.pressureinfo.loading;
  }
  showcol() {
    this.showcolumn = true;
  }
  //获取
  getAreaId() {
    let item = (this.$refs.tree as any).getSelectedNodes();
    if (item.length > 0) {
      this.pagerequest.areaId = item[0].id;
    }
    this.$store.commit("pressureinfo/setCurrentPage", 1);
    this.getpage();
  }
  //搜索树形结构
  searchTree(value: any, treeList) {
    if (!value) {
      this.areaTree = this.areaTreeList;
      return;
    }
    const rebuildData = (value, treeList) => {
      let newarr = [];
      treeList.forEach((element) => {
        if (element.children && element.children.length) {
          if (element.title != null && element.title.indexOf(value) > -1) {
            element.expand = true;
            newarr.push(element);
          }
          const ab = rebuildData(value, element.children);
          const obj = {
            ...element,
            expand: true,
            children: ab,
          };
          if (ab && ab.length) {
            newarr.push(obj);
          }
        } else {
          if (element.title != null && element.title.indexOf(value) > -1) {
            newarr.push(element);
          }
        }
      });
      return newarr;
    };
    this.areaTree = [];
    this.areaTree = rebuildData(value, this.areaTreeList);
  }
  //左侧菜单树
  getAreaTree() {
    this.$store
      .dispatch("area/getAreaLeftTree")
      .then((val) => {
        this.areaTree = val;
        this.areaTreeList = val;
      })
      .catch((err) => {
        console.log(err);
      });
  }
  pageChange(page: number) {
    this.$store.commit("pressureinfo/setCurrentPage", page);
    this.getpage();
  }
  pagesizeChange(pagesize: number) {
    this.$store.commit("pressureinfo/setPageSize", pagesize);
    this.getpage();
  }
  getpage() {
    this.pagerequest.maxResultCount = this.pageSize;
    this.pagerequest.skipCount = (this.currentPage - 1) * this.pageSize;
    this.$store.dispatch({
      type: "pressureinfo/getAll",
      data: this.pagerequest,
    });
  }
  get pageSize() {
    return this.$store.state.pressureinfo.pageSize;
  }
  get totalCount() {
    return this.$store.state.pressureinfo.totalCount;
  }
  get currentPage() {
    return this.$store.state.pressureinfo.currentPage;
  }
  columns = [
    {
      type: "index",
      width: 60,
      align: "left",
      fixed: "left",
      title: this.L("IndexNo"),
      sortId: 0,
    },
    {
      title: this.L("Organizations"),
      key: "organizationId",
      width: 130,
      sortId: 2,
      render: (h: any, params: any) => {
        let id = params.row.organizationId;
        let ite = JSON.parse(localStorage.getItem("organizations"));
        let info = ite.filter((p) => {
          return p.id == id;
        });
        return h(
          "span",
          {
            style: {
              display: "inline-block",
              width: "100%",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            },
            domProps: {
              title: info.length > 0 ? info[0].displayName : this.L("Unknown"),
            },
          },
          info.length > 0 ? info[0].displayName : this.L("Unknown")
        );
      },
    },
    {
      title: this.L("Areas"),
      key: "areaId",
      sortable: true,
      width: 150,
      sortId: 3,
      render: (h: any, params: any) => {
        let id = params.row.areaId;
        let ite = JSON.parse(localStorage.getItem("areas"));
        let info = ite.filter((p) => {
          return p.id == id;
        });
        return h(
          "span",
          {
            style: {
              display: "inline-block",
              width: "100%",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            },
            domProps: {
              title: info.length > 0 ? info[0].fullName : this.L("Unknown"),
            },
          },
          info.length > 0 ? info[0].fullName : this.L("Unknown")
        );
      },
    },
    {
      title: this.L("DeviceNo"),
      key: "deviceNo",
      sortable: true,
      width: 150,
      sortId: 3,
      fixed: "left",
      render: (h: any, params: any) => {
        return h(
          "span",
          {
            style: {
              display: "inline-block",
              width: "100%",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            },
            domProps: {
              title: params.row.deviceNo,
            },
          },
          params.row.deviceNo
        );
      },
    },
    {
      sortable: true,
      title: this.L("LastReadTime"),
      key: "lastReadTime",
      width: 150,
      sortId: 7,
      render: (h: any, params: any) => {
        return h(
          "span",
          params.row.lastReadTime == null
            ? ""
            : Moment(params.row.lastReadTime).format("YYYY-MM-DD HH:mm:ss")
        );
      },
    },
    {
      sortable: true,
      title: this.L("LastReportTime"),
      key: "lastReportTime",
      width: 150,
      sortId: 7,
      render: (h: any, params: any) => {
        return h(
          "span",
          params.row.lastReportTime == null
            ? ""
            : Moment(params.row.lastReportTime).format("YYYY-MM-DD HH:mm:ss")
        );
      },
    },
    {
      title: this.L("PressureValue"),
      key: "lastValue",
      width: 130,
      sortId: 8,
    },
    {
      title: this.L("TemperatureValue"),
      key: "temperatureValue",
      width: 130,
      sortId: 9,
    },
    {
      title: this.L("LiquidLevelValue"),
      key: "liquidLevelValue",
      width: 130,
      sortId: 10,
    },
    {
      sortable: true,
      title: this.L("OnLine") + this.L("State"),
      key: "lineState",
      width: 130,
      sortId: 26,
      render: (h: any, params: any) => {
        let str = this.L("OffLine");
        let id = params.row.lineState;
        if (id == 1) {
          str = this.L("OnLine");
        }
        return h("span", str);
      },
    },
    {
      title: this.L("CSQ"),
      key: "csq",
      width: 90,
      sortId: 38,
    },
    {
      title: this.L("RSRQ"),
      key: "rsrq",
      width: 90,
      sortId: 39,
    },
    {
      title: this.L("SNR"),
      key: "snr",
      width: 90,
      sortId: 40,
    },
    {
      title: this.L("RSRI"),
      key: "rSRI",
      width: 90,
      sortId: 40,
    },
    {
      title: this.L("CoverLevel"),
      key: "coverLevel",
      width: 130,
      sortId: 41,
    },
    {
      title: this.L("CellId"),
      key: "cellId",
      width: 130,
      sortId: 42,
    },
    {
      sortable: true,
      title: this.L("OnLineTime"),
      key: "onLineTime",
      width: 150,
      sortId: 43,
      render: (h: any, params: any) => {
        return h(
          "span",
          params.row.onLineTime == null
            ? ""
            : Moment(params.row.onLineTime).format("YYYY-MM-DD HH:mm:ss")
        );
      },
    },
    {
      sortable: true,
      title: this.L("OffLineTime"),
      key: "offLineTime",
      width: 150,
      sortId: 44,
      render: (h: any, params: any) => {
        return h(
          "span",
          params.row.offLineTime == null
            ? ""
            : Moment(params.row.offLineTime).format("YYYY-MM-DD HH:mm:ss")
        );
      },
    },
    {
      title: this.L("Voltage"),
      key: "voltage",
      width: 90,
      sortId: 45,
    },
    {
      title: this.L("IsWritePressure"),
      key: "isWritePressure",
      width: 150,
      sortId: 45,
    },
    {
      title: this.L("IsWriteTime"),
      key: "isWriteTime",
      width: 150,
      sortId: 45,
    },
    {
      title: this.L("DeviceWaringValue"),
      key: "deviceWaringValueId",
      sortable: true,
      width: 130,
      sortId: 22,
      render: (h: any, params: any) => {
        let id = params.row.deviceWaringValueId;
        let ite = JSON.parse(localStorage.getItem("devicewaringvalue"));
        if (ite != null) {
          let info = ite.filter((p) => {
            return p.id == id;
          });
          return h("span", info.length > 0 ? info[0].name : this.L("Unknown"));
        } else {
          return h("span", this.L("Unknown"));
        }
      },
    },
    {
      title: this.L("Longitude"),
      key: "longitude",
      width: 90,
      sortId: 46,
    },
    {
      title: this.L("Latitude"),
      key: "latitude",
      width: 90,
      sortId: 46,
    },
    {
      title: this.L("Waring"),
      key: "alarm",
      width: 90,
      sortId: 46,
    },
    {
      title: this.L("IP"),
      key: "serverIP",
      width: 130,
      sortId: 52,
    },
    {
      title: this.L("Port"),
      key: "serverPort",
      width: 130,
      sortId: 53,
    },
    {
      title: this.L("APN"),
      key: "apn",
      width: 130,
      sortId: 54,
    },
    {
      title: this.L("CycRate"),
      key: "cycRate",
      width: 150,
      sortId: 58,
    },
    {
      title: this.L("RetryCycle"),
      key: "retryCycle",
      width: 130,
      sortId: 63,
    },
    {
      title: this.L("CycSendPeriod"),
      key: "cycSendPeriod",
      width: 160,
      sortId: 64,
    },
    {
      title: this.L("TerminalTime"),
      key: "terminalTime",
      width: 160,
      sortId: 66,
      render: (h: any, params: any) => {
        return h(
          "span",
          params.row.terminalTime == null
            ? ""
            : Moment(params.row.terminalTime).format("YYYY-MM-DD HH:mm:ss")
        );
      },
    },
    {
      title: this.L("TimeDiff"),
      key: "timeDiff",
      width: 150,
      sortId: 67,
    },
    {
      title: this.L("RunDays"),
      key: "runDays",
      width: 130,
      sortId: 68,
    },
    {
      title: this.L("TVersion"),
      key: "tversion",
      width: 130,
      sortId: 69,
    },
    {
      title: this.L("HVersion"),
      key: "hVersion",
      width: 130,
      sortId: 69,
    },
    {
      title: this.L("Actions"),
      key: "Actions",
      width: 90,
      fixed: "right",
      sortId: 70,
      render: (h: any, params: any) => {
        let pressureinfolist = this.checkButtonAuth('pressRecordList');
        return h("div", [
          pressureinfolist ? h(
            "Button",
            {
              props: {
                type: "primary",
                size: "small",
              },
              style: {
                marginRight: "5px",
              },
              on: {
                click: () => {
                  this.readlist(params.row.pressureId);
                },
              },
            },
            this.L("PressureRecord")
          ) : '',
        ]);
      },
    },
  ];
  created() {
    this.getmodelType();
    this.getSupplier();
    //this.getmenu();
    this.getuserfields();
    this.getAreaTree();
    this.getpressure();
    this.getpage();
  }
  async getpressure() {
    let res = await this.$store
      .dispatch("pressure/getallpressure")
      .then((val) => {
        this.pressurelist = val;
      })
      .catch((err) => {
        console.log(err);
      });
  }
  //模型Id
  async getmodelType() {
    await this.$store
      .dispatch("pressuremodel/getalllist")
      .then((val) => {
        if (val.length > 0) {
          val.forEach((ele) => {
            this.modelType.push({ label: ele.name, value: ele.id });
          });
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }
  //供应商
  async getSupplier() {
    await this.$store
      .dispatch("supplier/getalllist")
      .then((val) => {
        if (val.length > 0) {
          val.forEach((ele) => {
            this.$data.suppliers.push({ label: ele.name, value: ele.id });
          });
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }
  //导出数据
  async exportData(type: any) {
    //console.log(type);
    let fileName = Moment().format("x");
    if (type === 'exportCurrentPage') {//当前页数据
      (this.$refs.selection as any).exportCsv({ filename: fileName, original: false, columns: this.columnlist });
    } else {
      this.pagerequest.skipCount = 0;
      this.pagerequest.maxResultCount = 10000;
      await this.$store.dispatch({
        type: "meter/getAll",
        data: this.pagerequest,
      });
      (this.$refs.selection as any).exportCsv({ filename: fileName, original: false, data: this.$store.state.meter.list, columns: this.columnlist });
    }
  }
  //数据
  data() {
    return {
      ispdetail: [],
      deviceType: [],
      suppliers: [],
      normalizer(node) {
        if (node.children && !node.children.length) {
          delete node.children;
        }
        return {
          id: node.id,
          label: node.label,
          children: node.children,
        };
      },
    };
  }
  changeSort(key) {
    if (key.order !== "normal") {
      this.pagerequest.sorting = key.key + " " + key.order;
    }
    this.getpage();
  }
  //查看采集记录
  readlist(id: string) {
    this.pressureId = id;
    this.readlistModalShow = true;
  }
  mounted() {
    if (window.innerHeight > 800) {
      this.height = window.innerHeight - 380;
    } else {
      this.height = window.innerHeight - 420;
    }
  }
}
